import * as ko from "knockout";

import * as shared from "./signInShared";
import { SignInPageMain } from "./signInPageMain";


/**
 * Settings for "SignInPageMessage.activate" calls.
 */
export interface SignInPageMessageActivationSettings {
    /**
     * How many milliseconds after activation should the initial focus be set.
     * If not specified, defaults to 500 milliseconds (default page transition animation duration).
     * If <= 0, focus is set instantly.
     */
    focusDelay?: number;

    /**
     * Server response that caused message-page to be activated.
     * Stored in "serverData" observable which is used by view to allow
     * server to override built-in texts and links.
     */
    serverData?: any;
}


/**
 * Viewmodel for text-only pages (pages showing a message to the user).
 * Multiple components can use this viewmodel (account locked out, support info, etc).
 */
export class SignInPageMessage {

    constructor(owner: shared.SignInPagesCollection, pageId: shared.SignInPageId) {
        this._owner = owner;
        this._pageId = pageId;
    }


    // -------------------------------------------------------------------------
    // Viewmodel properties
    // -------------------------------------------------------------------------

    /** Flag tracking focus of "submit" button. */
    submitFocus: ko.Observable<boolean> = ko.observable(false);

    /** Server response that caused message-page to be activated. */
    serverData: ko.Observable<any> = ko.observable(shared.emptyData);


    // -------------------------------------------------------------------------
    // Viewmodel actions
    // -------------------------------------------------------------------------

    /**
     * Transitions to this page + set initial focus.
     */
    activate(settings?: SignInPageMessageActivationSettings): void {
        this.serverData((settings && settings.serverData) || shared.emptyData);

        // initiate page transition
        this._owner.currentPageId(this._pageId);

        // set initial focus
        let focusDelay = (settings && settings.focusDelay);
        if (typeof focusDelay !== "number") { focusDelay = 500; }
        if (focusDelay > 0) {
            setTimeout(() => this.submitFocus(true), focusDelay);
        } else {
            this.submitFocus(true);
        }
    }

    /**
     * Transition back to main page.
     */
    submit(): void {
        const mainPage = this._owner.getPage<SignInPageMain>(shared.SignInPageId.Main);
        mainPage.activate({ transition: -1 });
    }


    // -------------------------------------------------------------------------
    // Private
    // -------------------------------------------------------------------------

    /** Collection that owns this page. Used for page transitions. */
    private _owner: shared.SignInPagesCollection;

    /** ID of the page that was instantiated with this viewmodel instance. */
    private _pageId: shared.SignInPageId; // readonly, initialized in constructor

}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/forms-signin/signInPageMessage.ts